import WorthyApi from 'lib/api/worthyApi';
import I18n from 'lib/i18n/i18n';
import rootStore from 'reducers';

export default class UserActions {
    static test() {
        console.log(rootStore);
    }
}

let _paymentDetailsRequestObject = function(component_key, val = null) {
    let itemId = null;
    try {
        itemId = rootStore.getState().PaymentDetails.item.id;
    } catch(e) {
        itemId = null;
    }
    return {
        page: 'payment_details',
        item_id: itemId,
        version: I18n.getString('user::paymentDetails::version'),
        component_key: component_key,
        value: val
    };
};
UserActions.PaymentDetails = {
    pageLoaded: function () {
        WorthyApi.logUserAction(_paymentDetailsRequestObject('payment_details_page_presented'));
    },
    idTypeSelected: function(val) {
        WorthyApi.logUserAction(_paymentDetailsRequestObject('id_type_selected', val));
    },
    idFocus: function() {
        WorthyApi.logUserAction(_paymentDetailsRequestObject('id_focus'));
    },
    idEntered: function(val) {
        WorthyApi.logUserAction(_paymentDetailsRequestObject('id_entered', val));
    },
    genderSelected: function(val) {
        WorthyApi.logUserAction(_paymentDetailsRequestObject('gender_selected', val));
    },
    dobDayOpened: function() {
        WorthyApi.logUserAction(_paymentDetailsRequestObject('dob_day_opened'));
    },
    dobDaySelected: function(val) {
        WorthyApi.logUserAction(_paymentDetailsRequestObject('dob_day_selected', val));
    },
    dobMonthOpened: function() {
        WorthyApi.logUserAction(_paymentDetailsRequestObject('dob_month_opened'));
    },
    dobMonthSelected: function(val) {
        WorthyApi.logUserAction(_paymentDetailsRequestObject('dob_month_selected', val));
    },
    dobYearOpened: function() {
        WorthyApi.logUserAction(_paymentDetailsRequestObject('dob_year_opened'));
    },
    dobYearSelected: function(val) {
        WorthyApi.logUserAction(_paymentDetailsRequestObject('dob_year_selected', val));
    },
    paymentTypeSelected: function(val) {
        WorthyApi.logUserAction(_paymentDetailsRequestObject('payment_type_selected', val));
    },
    bankNameFocus: function() {
        WorthyApi.logUserAction(_paymentDetailsRequestObject('bank_name_focus'));
    },
    bankNameEntered: function(val) {
        WorthyApi.logUserAction(_paymentDetailsRequestObject('bank_name_entered', val));
    },
    bankRoutingNumberFocus: function() {
        WorthyApi.logUserAction(_paymentDetailsRequestObject('bank_routing_number_focus'));
    },
    bankRoutingNumberEntered: function(val) {
        WorthyApi.logUserAction(_paymentDetailsRequestObject('bank_routing_number_entered', val));
    },
    bankAccountNumberFocus: function() {
        WorthyApi.logUserAction(_paymentDetailsRequestObject('bank_account_number_focus'));
    },
    bankAccountNumberEntered: function(val) {
        WorthyApi.logUserAction(_paymentDetailsRequestObject('bank_account_number_entered', val));
    },
    paypalFocus: function() {
        WorthyApi.logUserAction(_paymentDetailsRequestObject('paypal_focus'));
    },
    paypalEntered: function(val) {
        WorthyApi.logUserAction(_paymentDetailsRequestObject('paypal_entered', val));
    },
    checkNameFocus: function() {
        WorthyApi.logUserAction(_paymentDetailsRequestObject('check_name_focus'));
    },
    checkNameEntered: function(val) {
        WorthyApi.logUserAction(_paymentDetailsRequestObject('check_name_entered', val));
    },
    checkAddressFocus: function() {
        WorthyApi.logUserAction(_paymentDetailsRequestObject('check_address_focus'));
    },
    checkAddressEntered: function(val) {
        WorthyApi.logUserAction(_paymentDetailsRequestObject('check_address_entered', val));
    },
    checkAddress2Focus: function() {
        WorthyApi.logUserAction(_paymentDetailsRequestObject('check_address2_focus'));
    },
    checkAddress2Entered: function(val) {
        WorthyApi.logUserAction(_paymentDetailsRequestObject('check_address2_entered', val));
    },
    checkDetailsFocus: function() {
        WorthyApi.logUserAction(_paymentDetailsRequestObject('check_details_focus'));
    },
    checkDetailsEntered: function(val) {
        WorthyApi.logUserAction(_paymentDetailsRequestObject('check_details_entered', val));
    },
    submit: function() {
        WorthyApi.logUserAction(_paymentDetailsRequestObject('submit'));
    },
    auctionStarted: function() {
        WorthyApi.logUserAction(_paymentDetailsRequestObject('auction_started'));
    }
};

UserActions.supportNegotiation = function (page, version, itemId, component_key, val = null) {
    WorthyApi.logUserAction({page: page, itemId: itemId, version: version, component_key: component_key, value: val});
};

UserActions.pendingSale = function(event) {
    WorthyApi.logUserAction({
        page: 'pending_sale',
        itemId: rootStore.getState().Item.id,
        version: I18n.getString('itemPage::pendingSale::version'),
        component_key: event
    });
};

UserActions.myAccount = function(event, objectId, objectType='User') {
    WorthyApi.logUserAction({
        page: 'my_account',
        object_id: objectId,
        object_type: objectType,
        version: I18n.getString('myAccount::version'),
        component_key: event
    });
};

UserActions.sya = function(event, value = null, textVersion = 'A') {
    WorthyApi.logUserAction({
        page: 'pending_auction',
        itemId: rootStore.getState().Item.id,
        version: I18n.getString(`itemPage::pendingAuction::${textVersion}::version`),
        component_key: event,
        value: value
    });
};

UserActions.updateReservePrice = function(event) {
    WorthyApi.logUserAction({
        page: 'update_reserve_price',
        itemId: rootStore.getState().Item.id,
        version: I18n.getString('itemPage::updateReservePrice::version'),
        component_key: event
    });
}

UserActions.missingDetails = function(event,itemId) {
    WorthyApi.logUserAction({
        page: 'missing_details',
        itemId: itemId,
        version: I18n.getString('missingDetails::version'),
        component_key: event
    });
}

UserActions.listingPage = function(event, itemId, version) {
    WorthyApi.logUserAction({
        page: 'listing_page',
        itemId: itemId,
        version: version,
        component_key: event
    });
};

UserActions.hvListingPage = function(event, itemId, version) {
    WorthyApi.logUserAction({
        page: 'hv_listing_page',
        version: version,
        itemId: itemId,
        component_key: event
    });
};

UserActions.lightListingPage = function(event, itemId, version) {
    WorthyApi.logUserAction({
        page: 'light_listing_page',
        version: version,
        itemId: itemId,
        component_key: event
    });
};

UserActions.trendsPage = function(event, itemId, version = '1.1') {
    WorthyApi.logUserAction({
        page: 'trends_page',
        itemId: itemId,
        version: version,
        component_key: event
    });
};

UserActions.survey = function(event, objectId, objectType, value, surveyToShow) {
    WorthyApi.logUserAction({
        page: 'survey',
        objectId: objectId,
        objectType: objectType,
        version: I18n.getString(`survey::${surveyToShow}::version`) || "1.0",
        component_key: event,
        value: value
    });
}

UserActions.drawerClick = function(event) {
    WorthyApi.logUserAction({
        page: 'drawer',
        version: '1.0',
        component_key: event
    });
}

UserActions.logByEmail = function(event, email) {
    WorthyApi.logUserAction({
        page: 'log_by_email',
        event: event,
        email: email
    });
}

UserActions.uploadPhoto = function(event, itemId) {
    WorthyApi.logUserAction({
        page: 'upload_photo',
        itemId: itemId,
        component_key: event
    });
}

UserActions.lightTrendsPage = function(event, itemId, version) {
    WorthyApi.logUserAction({
        page: 'light_trends',
        itemId: itemId,
        version: version,
        component_key: event
    });
}

UserActions.manageCallPage = function(event, version = '1.0') {
    WorthyApi.logUserAction({
        page: 'manage_call',
        version: version,
        component_key: event
    });
}
